/**
 *
 * RequestType12970 constants
 *
 */

export const FOR_UNLOADING = '3754852407000';
export const PARKING_AT_MAIN_ENTRANCE = '3810974061000';
